import { useState } from 'react';
import { Info } from 'lucide-react';
import DialogModal from './dialog';

/**
 * Like Tooltip.js's hover-info icon, but for reference content too long for
 * a tooltip bubble (e.g. a full list of fields/operators/actions) -- clicking
 * the icon opens a modal instead of showing a hover popover.
 */
export default function HelpModalButton({ title, children, icon: Icon = Info, maxWidthClassName = 'max-w-4xl' }) {
	const [open, setOpen] = useState(false);

	return (
		<>
			<button
				type='button'
				className='inline-flex items-center align-middle'
				onClick={() => setOpen(true)}
				aria-label={title}
			>
				<Icon className='size-3.5 text-gray-400 hover:text-gray-600 cursor-pointer shrink-0' />
			</button>
			<DialogModal open={open} setOpen={setOpen} title={title} maxWidthClassName={maxWidthClassName}>
				{children}
			</DialogModal>
		</>
	);
}
